import CoreCrossLinksGrid from './CoreCrossLinksGrid';

export { type CoreCrossLinksGridProps } from './CoreCrossLinksGrid';
export default CoreCrossLinksGrid;
